import { store } from '../../store';

export const getUserToken = () => {
  const state = store.getState();
  return (
    state?.user?.token || {
      access: '',
      refresh: '',
    }
  );
};

export const getUserAuth = () => {
  const state = store.getState();
  return state?.user?.isAuth || false;
};

export const getUserInfo = () => {
  const state = store.getState();
  return state?.user?.userInfo || {};
};

export const getSelectedTemplateId = () => {
  const state = store.getState();
  return state?.user?.selectedTemplateId || 0;
};

export const getSelectedTimeRange = () => {
  const state = store.getState();
  return state?.user?.selectedTimeRange || null;
};

export const getOrgId = () => {
  const state = store.getState();
  return state?.user?.orgId || null;
};
